import React from 'react';
import { useHistory } from 'react-router';
import { Box, Grid, IconButton, Typography } from '@material-ui/core';
import { TitularTooltip } from '@campfire/titular-tooltip';
import { ChevronLeft } from '@material-ui/icons';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';

export const ErrorPrompt = () => {
  const { isMobile, theme } = useCampfireTheme();
  const history = useHistory();

  return (
    <>
      <Box paddingTop={8} paddingBottom={isMobile ? 0 : 8} position='relative'>
        <TitularTooltip description='Back to sign in'>
          <Box position='absolute' top={12} left={12}>
            <IconButton onClick={() => history.push(`/create-trial`)}>
              <ChevronLeft color='action' />
            </IconButton>
          </Box>
        </TitularTooltip>
        <Grid justify='center' container style={{ flexGrow: 1 }}>
          <Grid item xs={12} sm={10} style={{ textAlign: 'center', paddingLeft: 8, paddingRight: 8 }}>
            <Typography variant='h4' style={{ color: '#343434' }}>
              Oops, Something went wrong.
            </Typography>
            <Typography
              component='span'
              variant='body2'
              style={{ marginTop: 16, color: theme.color.grey.neutralBrand400 }}
            >
              We could not process your request. Please try again.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
